const USDollarFormatter = (fractions?: number) =>
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: fractions ?? 0,
    minimumFractionDigits: fractions ?? 0,
  })

export { USDollarFormatter }
